import { FC } from 'react';
import { IICartGroupBar } from 'mod/cart/interface';
import { Checkbox } from 'antd';
import type { CheckboxChangeEvent } from 'antd/lib/checkbox';
import OrderProductTag from '@base/snippets/OrderProductTag';
import styles from './cartMenu.module.less';
import { CartGroupHeaderTip } from 'mod/cart/CartGroupHeaderTip';
import { CartType } from '@base/cart/useCart';
import { getTagConfig } from 'mod/product/utils';
import { ProductTag } from '@base/snippets/ProductTag';

type IGroupHeaderProps = {
    data: IICartGroupBar;
    isBatchList: boolean;
    groupCheckAll: boolean;
    onGroupCheckAll: (e: CheckboxChangeEvent) => void;
    loadCart: CartType['loadCart'];
    editable: boolean;
};

export const GroupHeader: FC<IGroupHeaderProps> = props => {
    const { data, isBatchList, groupCheckAll, onGroupCheckAll, loadCart, editable } = props;
    const { tag, tips } = data;

    // 获取配置tag
    const tagConfig = tag && getTagConfig(
        tag.toLocaleLowerCase() as any,
        'picTag'
    )

    return !tag && !tips ? null : (
        <div className={styles['group-header']}>
            <div className={styles['col-checkbox']}>
                {(!isBatchList || editable) && (
                    <Checkbox
                        // value={`group-${gr}`}
                        checked={groupCheckAll}
                        onChange={onGroupCheckAll}
                        className={isBatchList ? styles['checkbox-batch'] : styles['checkbox-common']}
                        // disabled={!batchActive && (isChangingQty || stockNum === 0)}
                    />
                )}
            </div>

            {!!tag && (
                <>
                    {tagConfig ? (
                        <ProductTag tagConfig={tagConfig}/>
                    ) : (
                        <OrderProductTag tag={tag} absolute={false}/>)
                    }
                </>
            )}

            <CartGroupHeaderTip className={styles.tips} data={data} loadCart={loadCart}/>
        </div>
    )
};
